export default "__VITE_ASSET__DiWe4F0Y__"